import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Navigate, useNavigate } from "react-router-dom";
import { Button, TextField } from '@mui/material';
import { Link } from 'react-router-dom'
import {NotificationContainer, NotificationManager} from 'react-notifications';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InvoiceUpload from '../../components/InvoiceUpload';
import ImageModal from '../../components/ImageModal';
import Tooltip from '@mui/material/Tooltip';

const columns = [
  {
    id: "expand",
    label: "",
    minWidth: 10,
  },
  {
    id: "upload_invoice",
    label: "Invoice Document",
    minWidth: 120,
  },
  {
    id: "project_name",
    label: "Project Name",
    minWidth: 100,
  },
  {
    id: "launch_name",
    label: "Launch Name",
    minWidth: 100,
  },
  {
    id: "applications",
    label: "Applications",
    minWidth: 100,
  },
  {
    id: "eligibility_status",
    label: "Eligibility Status",
    minWidth: 100,
  },
  {
    id: "eligibility_amount",
    label: "Eligibility Amount",
    minWidth: 100,
  },
  {
    id: "tds_total",
    label: "TDS Amount",
    minWidth: 100,
  },
  {
    id: "gst_amount",
    label: "GST Amount",
    minWidth: 100,
  },
  {
    id: "invoice_status",
    label: "Invoice Status",
    minWidth: 100,
  },
  {
    id: "payment_status",
    label: "Payment Status",
    minWidth: 100,
  },
  {
    id: "remarks",
    label: "Remark",
    minWidth: 100,
  },
];

const recordColumns = [
  // {
  //   id: "application_id",
  //   label: "Application_id",
  //   // minWidth: 150,
  // },
  {
    id: "application_date",
    label: "Application Date",
    // minWidth: 100,
  },
  {
    id: "customer_name",
    label: "Customer Name",
    // minWidth: 150,
  },
  {
    id: "cp_firm_name",
    label: "Cp Firm Name",
    // minWidth: 150,
  },
  {
    id: "eligibility_status",
    label: "Eligibilty Status",
    // minWidth: 150,
  },
  {
    id: "eligible_amount",
    label: "Eligible Amount",
    // minWidth: 150,
  },
  {
    id: "gst_amount",
    label: "Gst Amount",
    // minWidth: 150,
  },
  {
    id: "incentive_amount",
    label: "Incentive Amount",
    // minWidth: 150,
  },
  // {
  //   id: "invoice_id",
  //   label: "Invoice_id",
  //   // minWidth: 150,
  // },
  // {
  //   id: "invoice_status",
  //   label: "Invoice Status",
  //   // minWidth: 150,
  // },
  // {
  //   id: "launch_name",
  //   label: "Launch_name",
  //   // minWidth: 150,
  // },
  {
    id: "net_amount",
    label: "Net Amount",
    // minWidth: 150,
  },
  // {
  //   id: "payment_status",
  //   label: "Payment Status",
  //   // minWidth: 150,
  // },
  // {
  //   id: "project_name",
  //   label: "Project_name",
  //   // minWidth: 150,
  // },
  {
    id: "tds",
    label: "Tds",
    // minWidth: 150,
  },
];



function Row(props) {
  const { row, hoabl_id, handleDataRefresh } = props;
  const [open, setOpen] = React.useState(false);
  const type_id = row?.records?.map(item => item.id)

  const handleDataReset = () => {
    handleDataRefresh()
  }

  const invoiceDocumentRender = (data) => {
    if (data.eligibility_status==='No'){
      return null
    }
    if (data.invoice_status === "REJECTED"){
      return (
        <div style={{display:"flex"}}>
          <InvoiceUpload ls_token_key="CP-USER-AUTH" type="app_incentive" type_id={type_id} handleDataRefresh={handleDataReset} hoabl_id={hoabl_id} invoice_value={row.eligibility_amount} />
          <ImageModal url={row.invoice_img_url} ls_token_key={"CP-USER-AUTH"} />
        </div>
      )
    }
    if (row.invoice_img_url){
      return <ImageModal url={row.invoice_img_url} ls_token_key={"CP-USER-AUTH"} />
    }

    return <InvoiceUpload ls_token_key="CP-USER-AUTH" type="app_incentive" type_id={type_id} handleDataRefresh={handleDataReset} hoabl_id={hoabl_id} invoice_value={row.eligibility_amount} />
  }

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        {columns.map((column) => {
          const value = row[column.id];

          if (column.id === 'upload_invoice'){
            return (
              <TableCell key={column.id}>
                {invoiceDocumentRender(row)}  
              </TableCell>
            )
          }

          if (column.id === 'expand'){
            return (
              <TableCell key={column.id}>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
            )
          }
          
          if (column.label === 'Action'){
            console.log(row['hoabl_id'])
            return(
              <TableCell key={column.id} align={column.align}>
                <Link to={`edit/${row['id']}`} style={{all:'unset'}}>
                  <Button>Edit</Button>
                </Link>
              </TableCell>
            )
          }
          return (
            <TableCell key={column.id} align={column.align}>
              {typeof(value) === 'number'
                              ? value.toFixed(2)
                              : value}
            </TableCell>
          );
        })}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={18}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box id="box" sx={{ margin: 1, maxWidth:'95vw', overflow:'scroll' }}>
              {/* <Typography variant="h6" gutterBottom component="div">
                History
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                  {recordColumns?.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth,}}
                      className="clientthtcell"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.records?.map((recordRow) => (
                    <TableRow key={recordRow.id}>
                      {recordColumns?.map((column) => {
                        const value = recordRow[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {typeof(value) === 'number'
                              ? value.toFixed(2)
                              : value}
                          </TableCell>
                        )
                      })}
                      
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

// Row.propTypes = {
//   row: PropTypes.shape({
//     calories: PropTypes.number.isRequired,
//     carbs: PropTypes.number.isRequired,
//     fat: PropTypes.number.isRequired,
//     history: PropTypes.arrayOf(
//       PropTypes.shape({
//         amount: PropTypes.number.isRequired,
//         customerId: PropTypes.string.isRequired,
//         date: PropTypes.string.isRequired,
//       }),
//     ).isRequired,
//     name: PropTypes.string.isRequired,
//     price: PropTypes.number.isRequired,
//     protein: PropTypes.number.isRequired,
//   }).isRequired,
// };


// export default function CollapsibleTable() {
export default function DataList_v2(props) {
  const { data, rows, hoabl_id, handleDataCall, setRows, setData, projectName,launchName } = props
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const navigate = useNavigate()

  let authToken;
  try{
    authToken = JSON.parse(localStorage.getItem('CP-USER-AUTH'))
  }catch(err){
    authToken = null
  }
  React.useEffect(() => {
    
    setPage(0)
    setRows(() => {
      return data.filter((item) => ((item.project_name).toLowerCase().includes(projectName.toLowerCase()) && (item.launch_name).toLowerCase().includes(launchName.toLowerCase())))
    })
  }, [projectName,launchName])
  
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };


  const handleSearch = (e) => {
    // console.log(e.target.value,data)
    setPage(0)
    setRows(() => {
      return data.filter((item) => (item.project_name+item.launch_name+item.eligibility_status).toLowerCase().includes(e.target.value.toLowerCase()))
    })
  }
  return (
    <div style={{padding:"1rem 0"}}>
      <div style={{width:'100%' ,padding:"0 0 1rem 0", display:'flex', justifyContent: 'space-between'}}>
        <Tooltip title="Search by Eligibility Status, Customer, Plot Number">
          <TextField label="Search" onChange={handleSearch} style={{width:"250px"}} />
        </Tooltip>
        {/* <Button className="registrationbutton"  variant="contained" onClick={() => navigate('create') } >Create</Button> */}
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              {columns?.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth,}}
                  className="clientthtcell"
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row,index) => {
                return (
                  <Row key={index} row={row} hoabl_id={authToken?.info?.hoabl_id} handleDataRefresh={handleDataCall} hover role="checkbox" tabIndex={-1}  />                  
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5,10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}